import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";
import Widget from "./Widget";
import EcomDashChart from "./EcomDashChart";
import ProductlistMostselling from "./ProductlistMostselling";

const EcomDash = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="eCommerce Dashboard" pageType="Sliced" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <Widget/>
        <EcomDashChart />
        <ProductlistMostselling />
      </div>
    </React.Fragment>
  );
};

export default EcomDash;
